import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: theme.spacing(2),
    overflow: "hidden",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: theme.palette.text.secondary,
    color: theme.palette.common.white,
    padding: theme.spacing(2),
  },
  headerTitle: {
    fontWeight: 700,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    height: 520,
    backgroundColor: theme.palette.common.white,
  },
  description: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
  },
  descriptionTitle: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "gray",
  },
  descriptionText: {
    color: theme.palette.common.black,
  },
  messageArea: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  messageBubble: {
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1.5),
    maxWidth: "80%",
    fontSize: "0.9rem",
    wordBreak: "break-word",
  },
  messageUser: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    alignSelf: "flex-end",
  },
  messageSupport: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.secondary,
    alignSelf: "flex-start",
  },
  messageTime: {
    fontSize: "0.7rem",
    marginTop: theme.spacing(0.5),
    textAlign: "right",
    opacity: 0.7,
  },
  messageAttachment: {
    marginBottom: theme.spacing(1),
  },
  attachmentImage: {
    width: 180,
    maxWidth: "100%",
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
    display: "block",
  },
  attachmentLink: {
    color: theme.palette.primary.main,
    textDecoration: "underline",
    fontSize: "0.8rem",
  },
  inputContainer: {
    borderTop: "1px solid rgba(0, 0, 0, 0.08)",
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "flex-end",
    gap: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
  },
  hiddenInput: {
    display: "none",
  },
  attachButton: {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
    width: 44,
    height: 44,
  },
  inputArea: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.75),
  },
  attachmentList: {
    display: "flex",
    flexWrap: "nowrap",
    gap: theme.spacing(0.75),
    overflowX: "auto",
    overflowY: "hidden",
    paddingBottom: theme.spacing(0.25),
    "&::-webkit-scrollbar": {
      height: 6,
    },
  },
  attachmentChip: {
    display: "flex",
    alignItems: "center",
    flex: "0 0 auto",
    gap: theme.spacing(0.5),
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(0.15, 0.8),
  },
  attachmentName: {
    fontSize: "0.72rem",
    color: theme.palette.text.secondary,
    maxWidth: 110,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  removeAttachmentButton: {
    border: "none",
    background: "transparent",
    color: theme.palette.primary.main,
    cursor: "pointer",
    fontWeight: 700,
    padding: 0,
    lineHeight: 1,
  },
  input: {
    width: "100%",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.25, 1.5),
    fontFamily: theme.typography.fontFamily,
    fontSize: "1rem",
    lineHeight: 1.4,
    resize: "none",
    minHeight: 44,
    maxHeight: 110,
    overflowY: "auto",
    boxSizing: "border-box",
  },
  sendButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    borderRadius: theme.spacing(1.25),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    height: 46,
    minWidth: 110,
    padding: theme.spacing(0, 2),
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "1rem",
    lineHeight: 1,
    whiteSpace: "nowrap",
  },
  disabledButton: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
  closedNotice: {
    padding: theme.spacing(2),
    textAlign: "center",
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.text.disabled,
  },
  helperText: {
    ...theme.typography.body2,
    color: theme.palette.text.disabled,
    textAlign: "center",
  },
  statusText: {
    fontSize: "0.75rem",
    opacity: 0.8,
  },
  closeButton: {
    color: theme.palette.common.white,
  },
}));

export default useStyles;
